import { usePlayer } from "../context/PlayerContext";
import { useT } from "../lib/i18n";

const Btn = ({ on, testid, label, hint, onClick }) => (
  <button data-testid={testid} data-active={on ? "true" : "false"} onClick={onClick}
    className={`select-none border px-3 py-3 text-left transition-[background-color,border-color] duration-75 ${on ? "bg-[#1FD1FF] text-black border-[#1FD1FF]" : "border-white/15 bg-[#0A1424] hover:border-white/40"}`}>
    <span className="font-display text-xl leading-none block">{label}</span>
    <span className={`font-mono text-[10px] uppercase tracking-widest ${on ? "text-black/70" : "text-[#A8B3C4]"}`}>{hint}</span>
  </button>
);

export const MixFxRow = ({ compact, active }) => {
  const { mix, mixFx } = usePlayer();
  const { t } = useT();
  const p = compact ? "mixfx-compact" : "mixfx";
  if (!mix) return <p data-testid={`${p}-idle`} className="font-mono text-xs text-[#A8B3C4] mb-5">{t("mixfx.idle")}</p>;
  const echo = active.has("mix:echo");
  const verb = active.has("mix:reverb");
  return (
    <div className="mb-6" data-testid={`${p}-row`}>
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1FD1FF] mb-2">{t("mixfx.title")}</p>
      <div className="grid grid-cols-2 gap-2 max-w-md">
        <Btn testid={`${p}-echo`} on={echo} label="Echo" hint={t("mixfx.toggle")} onClick={() => mixFx.echo(!echo)} />
        <Btn testid={`${p}-reverb`} on={verb} label="Reverb" hint={t("mixfx.toggle")} onClick={() => mixFx.reverb(!verb)} />
      </div>
    </div>
  );
};
